/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {clsx} from 'clsx';
import {Button, Typography} from 'onboarding-components';

import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets/assets';

import styles from './banner.module.styl';

export enum BannerType {
  Info = `info`,
  Marketing = `marketing`,
}

const backgroundColorStyle = {
  [BannerType.Info]: styles.infoColor,
  [BannerType.Marketing]: styles.marketingColor,
};

export const Banner = ({title, description, actionName, action, type = BannerType.Info, isVisible = true}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div className={clsx(styles.banner, backgroundColorStyle[type])}>
        {type === BannerType.Marketing && <img className={styles.bannerImage} src={IMMERSIVE_ASSETS.bannerImage} />}
        <div className={styles.bannerContent}>
          <div>
            <div className={styles.bannerTitle}>
              <Typography variant='bodySm' weight='bold'>
                {title}
              </Typography>
            </div>
            <div className={styles.bannerDescription}>
              <Typography variant='bodySm' weight='regular'>
                {description}
              </Typography>
            </div>
          </div>
          <div className={styles.bannerButton}>
            <Button onClick={action} variant='inline' includeArrow={false}>
              {actionName}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
